import React, { useState, useEffect } from 'react';
import { Router } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import Auth from 'src/components/Auth';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
import ScrollReset from 'src/components/ScrollReset';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import Routes from 'src/Routes';
import configSingletonInstance from 'src/ConfigSingleton';
const history = createBrowserHistory();
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%'
      },
      body: {
        height: '100%',
        width: '100%'
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }
  })
);

function App() {
  useStyles();

  const { settings } = useSettings();
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);

  useEffect(() => {
    const getConfig = () => {
      fetch('/config.json')
        .then(r => r.json())
        .then(configs => {
          configSingletonInstance.setConfig(configs);
          setIsConfigLoaded(true);
        })
        .catch(error => {
          setIsConfigLoaded(true);
        });
    };
    getConfig();
  }, []);

  if (!isConfigLoaded) {
    return null;
  }

  const envConfig = configSingletonInstance.getConfig();
  const options = {
    api_host: envConfig.REACT_APP_POSTHOG_HOST,
    defaults: '2025-05-24',
    capture_console: true
  };

  return (
    <PostHogProvider apiKey={envConfig.REACT_APP_POSTHOG_PROJECT_TOKEN} options={options}>
      <ThemeProvider theme={createTheme(settings)}>
        <StylesProvider jss={jss}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider maxSnack={1}>
              <Router history={history}>
                <Auth>
                  <ScrollReset />
                  <GoogleAnalytics />
                  <Routes />
                </Auth>
              </Router>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </ThemeProvider>
    </PostHogProvider>
  );
}

export default App;
